import { Injectable } from "@angular/core";
import { map } from "rxjs";
import { HttpService } from "../common/http-service";
import { environment } from 'src/environments/environment';
import { HttpClient, HttpHeaders, HttpRequest } from "@angular/common/http";
import { SendChatMessageModel } from "../../models/send-chat-message.model";
import { GetChatHistoryModel } from "../../models/get-chat-history.model";

const CHAT_API = environment.apiURL + '/api/adv/Chat/';

@Injectable({
    providedIn: 'root'
})
export class ChatService {
    //#region Fields
    //#endregion

    //#region Constructor

    constructor(private _httpService: HttpService, private _httpClient: HttpClient) {
    }
    //#endregion

    //#region Public Methods

    //sendchatmessage - POST
    sendchatmessage(model: SendChatMessageModel){
        var url = CHAT_API + "sendchatmessage";
        return this._httpService.httpPost(url,model)
            .pipe(map(response => {
                return response;
            }))
    }
    //getchathistory - GET
    getchathistory(chatReq: GetChatHistoryModel){
        var url = CHAT_API + "getchathistory?SubscriberChatId=" + chatReq.SubscriberChatId + "&SubscriberId=" + chatReq.SubscriberId + "&EventId=" +chatReq.EventId;
        return this._httpService.httpGet(url)
            .pipe(map(response => {
                return response;
            }))
    }
    //getallchats - GET
    getallchats(id: string){
        var url = CHAT_API + "getallchats?UserId=" + id;
        return this._httpService.httpGet(url)
            .pipe(map(response => {
                return response;
            }))
    }

    // getadminbyid(id: string) {
    //     var url = ADM_API + 'getadmin?adminId=' + id;
    //     return this._httpService.httpGet(url)
    //         .pipe(map(resposne => {
    //             return resposne;
    //         }));
    // }
    //#endregion
}